// client/src/pages/ShopPOS/components/CloseTypeModal.tsx
import { Button } from "@/components/ui/button";

interface CloseTypeModalProps {
  show: boolean;
  userName: string;
  onSelect: () => void;
  onCancel: () => void;
}

export function CloseTypeModal({
  show,
  userName,
  onSelect,
  onCancel,
}: CloseTypeModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[90] p-4">
      <div className="bg-background rounded-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-2 text-center">Cierre de Turno</h3>
        <p className="text-muted-foreground text-center mb-2">
          Vendedor: <span className="font-semibold">{userName}</span>
        </p>
        <div className="space-y-4">
          <button
            onClick={onSelect}
            className="w-full p-4 border rounded-lg hover:border-primary hover:bg-primary/5 transition-all text-left flex items-start gap-4"
          >
            <div className="text-3xl">🔒</div>
            <div className="flex-1">
              <div className="font-bold text-lg">Cierre de turno</div>
              <div className="text-sm text-muted-foreground">
                Cierre de turno del vendedor
              </div>
            </div>
          </button>
        </div>

        <div className="mt-6">
          <Button variant="outline" className="w-full" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}
